// 51嘿料 首页静态内容数据（纯展示，不接接口）
// 所有话题均为中性、泛化示例，用于呈现模块气质。

// 压顶更新条：刚刚刷新的短动态
export const updateTicker = [
  "「#直播电商价格乌龙」风向微调，支持方占比回升至46%",
  "新上榜「#综艺剧本化吐槽」，12分钟讨论+2.1万",
  "「#公司群秒解散」进入今日热议榜前五",
  "「#国货翻车复盘」评论区吵出300+高赞楼中楼",
  "「#996年轻人摆摊」争议焦点持续升温",
  "「#游戏厂商补偿礼包」多数网友表示「差评但不退坑」",
  "「#素人逆袭走红」出现反转新料，风向由赞转疑",
  "「#外包甩锅现场」职场吐槽区热度跃升第一",
];

// 今日热议榜：排名 + 标题 + 短摘要 + 分区 + 热度/趋势
export const rankTopics = [
  {
    rank: 1,
    title: "某头部直播间凌晨标错价，抢单党涌入后遭遇变价",
    digest: "网友凌晨发现标价异常后大量下单，数小时后台悄悄改回原价，讨论焦点从「薅羊毛」转向「平台是否该兜底」。",
    zone: "消费维权",
    heat: 186.4,
    trend: "up",
  },
  {
    rank: 2,
    title: "公司群深夜被秒解散，第二天同事集体默认「没发生过」",
    digest: "一次深夜秒解散引爆打工人的共情，高赞几乎都指向「老板逃避沟通」而非事件本身，争议焦点落在职场边界感。",
    zone: "职场吐槽",
    heat: 152.1,
    trend: "up",
  },
  {
    rank: 3,
    title: "综艺预告被指「剧本太假」，网友开始逐帧拆穿剪辑",
    digest: "本季节目冲突镜头被逐一标注疑似设计痕迹，评论区分成「图一乐」与「反感被套路」两派，风向仍在反复。",
    zone: "综艺名场面",
    heat: 121.7,
    trend: "flat",
  },
  {
    rank: 4,
    title: "国货品牌翻车复盘：道歉声明越写越「万能模板」",
    digest: "复盘帖指出多家品牌的致歉信结构几乎一致，网友观点从「支持国货」转向「别拿情怀当挡箭牌」，争议焦点清晰。",
    zone: "品牌风波",
    heat: 98.6,
    trend: "up",
  },
  {
    rank: 5,
    title: "独立游戏厂商发补偿礼包，玩家态度：骂归骂、玩归玩",
    digest: "「差评但不退坑」成为评论区最高频句式，舆论风向罕见地出现「边骂边支持」的摇摆样本。",
    zone: "科技游戏圈",
    heat: 76.2,
    trend: "down",
  },
  {
    rank: 6,
    title: "外包员工一句「这需求不是我写的」带崩整场线上会",
    digest: "甩锅名场面被转出圈，讨论焦点落在「责任如何定义」：是制度问题还是个人问题，正反两方都很硬。",
    zone: "职场吐槽",
    heat: 63.9,
    trend: "up",
  },
  {
    rank: 7,
    title: "素人逆袭走红后遭扒旧料，舆论风向一夜由赞转疑",
    digest: "励志叙事被考古式检索打断，评论区吵成两个阵营：相信努力值得被看见 vs 质疑人设经不起放大。",
    zone: "社会热议",
    heat: 55.3,
    trend: "flat",
  },
  {
    rank: 8,
    title: "「00后整顿职场」话题再被翻出，这次聊的是成本",
    digest: "从段子聊到现实成本，争议焦点从「爽不爽」转向「能撑多久」，讨论热度的形态明显在变。",
    zone: "职场吐槽",
    heat: 41.8,
    trend: "down",
  },
];

// 分区索引：合集/索引醒目
export const partitions = [
  {
    name: "社会热议",
    en: "SOCIAL",
    desc: "民生、热点事件与价值讨论",
    count: 3280,
    hot: 8,
    tags: ["反转", "共情"],
  },
  {
    name: "消费维权",
    en: "RIGHTS",
    desc: "翻车、价差与售后拉锯",
    count: 2156,
    hot: 6,
    tags: ["平台", "兜底"],
  },
  {
    name: "职场吐槽",
    en: "WORKPLACE",
    desc: "开会、甩锅与边界感",
    count: 1924,
    hot: 9,
    tags: ["甩锅", "打工人"],
  },
  {
    name: "综艺名场面",
    en: "SHOWBIZ",
    desc: "剪辑、剧本与高光切片",
    count: 1670,
    hot: 3,
    tags: ["剧本", "破圈"],
  },
  {
    name: "品牌风波",
    en: "BRANDS",
    desc: "致歉、营销与口碑翻车",
    count: 1408,
    hot: 4,
    tags: ["模板", "态度"],
  },
  {
    name: "科技游戏圈",
    en: "TECH&GAME",
    desc: "厂商、玩家与版本争议",
    count: 1203,
    hot: 2,
    tags: ["补偿", "骂归骂"],
  },
];

// 争议焦点：吵起来的焦点，正反两派网友观点
export const debateFights = [
  {
    title: "直播变价该不该兜底？",
    context: "主播声称「误标」，抢单方坚持「成交即契约」，平台迟迟没表态，争议焦点被顶到榜首。",
    positive: {
      label: "支持兜底履约",
      pct: 46,
      points: ["后台改价属于单方违约", "一次乌龙不该由消费者买单", "平台需给出统一赔付口径"],
    },
    negative: {
      label: "主张平台免责",
      pct: 54,
      points: ["明显异常的bug单不该强兑", "恶意囤单者要区分对待", "规则写清比施舍更重要"],
    },
    note: "风向正在从「骂平台」往「别误伤正常买家」漂移",
  },
  {
    title: "秒解散群里聊了什么、该不该复盘？",
    context: "深夜解散后第二天全员沉默，有人想翻篇，有人觉得该把话说开，争议焦点落在职场边界。",
    positive: {
      label: "建议当面说清",
      pct: 61,
      points: ["解散不等于问题消失", "留证据是成年人礼貌", "冷处理最伤团队信任"],
    },
    negative: {
      label: "主张翻篇别深挖",
      pct: 39,
      points: ["私群本就该及时止语", "过度复盘只会更尴尬", "打工别把边界感丢掉"],
    },
    note: "「边界感」成了两派共同的隐含前提",
  },
  {
    title: "综艺剧本化，观众到底在气什么？",
    context: "逐帧拆穿剪辑后，两派其实不太冲突：反对者骂「被当傻子」，接受者说「有剧本也是下饭」。",
    positive: {
      label: "反感被套路",
      pct: 57,
      points: ["冲突痕迹太重出戏", "真人秀不该全是表演", "越拆越没追下去的欲望"],
    },
    negative: {
      label: "图一乐就行",
      pct: 43,
      points: ["综艺本就有剧本属性", "纠结真假反而错过乐子", "剪辑也是创作的一部分"],
    },
    note: "舆论风向：反感情绪在上行，但还没到弃综",
  },
];

// 评论区高赞切片：标题 + 一句话观点 + 打码ID + 赞数 + 立场
export const commentClips = [
  {
    topic: "直播变价该不该兜底",
    quote: "我不是薅羊毛的，就是正常刷到下单，早上醒来发现被改价，平台连条通知都没有。我不是要占便宜，我是要个说法。",
    user: "云*吃瓜",
    likes: 8.6,
    stance: "支持履约",
    tone: "accent",
  },
  {
    topic: "秒解散群",
    quote: "真正的问题不是群里说了什么，是老板从来没打算听我们说完。解散的一瞬间，我就知道答案了。",
    user: "打*人一枚",
    likes: 6.2,
    stance: "怒其不争",
    tone: "primary",
  },
  {
    topic: "综艺剧本化",
    quote: "说实话我早当连续剧看了，撕得好看就行。但你也别一边演一边标榜「绝对真实」，这才是大家最气的点。",
    user: "综*十级学者",
    likes: 4.7,
    stance: "半看半嘲",
    tone: "secondary",
  },
  {
    topic: "国货翻车道歉",
    quote: "道歉信写得再漂亮不如做一次实质整改。模板道歉看多了，我现在只关心下一条还能不能经得起考古。",
    user: "老*实人",
    likes: 3.9,
    stance: "看整改",
    tone: "primary",
  },
  {
    topic: "独立游戏补偿礼包",
    quote: "差评是不满意现在的版本，不退坑是还想等它变好。这两件事一点都不矛盾，别拿「真爱」绑架我。",
    user: "买*首发",
    likes: 3.1,
    stance: "边骂边玩",
    tone: "accent",
  },
];

// 实时热议短讯流：时间线、高密度
export const feedUpdates = [
  {
    time: "2分钟前",
    title: "某电商平台被要求公开「误标价」处理明细，已发站内说明",
    digest: "说明仅提及「订单量较大、按单处理」，未给出统一赔付比例，评论区仍在追问口径。",
    zone: "消费维权",
    heat: 3.4,
  },
  {
    time: "11分钟前",
    title: "「公司群秒解散」职场吐槽区热度登顶，涌现大量同类投稿",
    digest: "相似经历投稿密集上线，多数集中在沟通渠道与「被通知感」缺失，风向持续发酵。",
    zone: "职场吐槽",
    heat: 2.7,
  },
  {
    time: "24分钟前",
    title: "综艺逐帧拆解帖获官方回应：称系「剪辑节奏」非人为冲突",
    digest: "回应语气较软，拆解派认为未正面回应，支持派则认为「解释过度反而坐实」，焦点升级。",
    zone: "综艺名场面",
    heat: 2.1,
  },
  {
    time: "40分钟前",
    title: "国货品牌复盘汇总帖更新：新增3家致歉声明结构对比",
    digest: "表格化对比让「万能模板」说法更具体，舆论风向微调，讨论焦点从情绪转向结构。",
    zone: "品牌风波",
    heat: 1.8,
  },
  {
    time: "1小时前",
    title: "独立游戏厂商开启灰度补偿，首批玩家晒单：礼包「能看」",
    digest: "晒单与吐槽并行，「差评但不退坑」句式继续被引用，厂商态度被评价为「迟到但诚恳」。",
    zone: "科技游戏圈",
    heat: 1.5,
  },
  {
    time: "2小时前",
    title: "素人逆袭旧料再发酵，原合作方晒出聊天记录时间线",
    digest: "证据细节让「励志 vs 人设」两派各自加强了论据，讨论热度小幅抬头，仍未决出胜负。",
    zone: "社会热议",
    heat: 1.2,
  },
];

// 舆论风向温度计：三组话题的支持/反对/观望比例
export const sentimentTopics = [
  {
    topic: "直播变价兜底",
    support: 46,
    oppose: 38,
    neutral: 16,
    note: "观望盘多在等平台口径",
  },
  {
    topic: "综艺剧本化",
    support: 43,
    oppose: 57,
    neutral: 0,
    note: "反感情绪上行，但未到弃综",
  },
  {
    topic: "外包甩锅责任划分",
    support: 55,
    oppose: 45,
    neutral: 0,
    note: "制度派与个人派胶着",
  },
];

// 热议关键词：话题关键词热度（仅作阅读扩展，不做隐藏堆词）
export const hotKeywords = [
  { word: "误标价", heat: 98 },
  { word: "兜底", heat: 91 },
  { word: "秒解散", heat: 87 },
  { word: "边界感", heat: 80 },
  { word: "剧本化", heat: 74 },
  { word: "甩锅", heat: 68 },
  { word: "道歉模板", heat: 61 },
  { word: "边骂边玩", heat: 55 },
  { word: "人设考古", heat: 47 },
  { word: "整顿职场", heat: 40 },
];